
export function decimalOrBust(number) {
  const num = parseFloat(number);
  if (Math.abs(num) % 1 > 0) return num.toFixed(2);
  return parseInt(number, 10);
}


// WEBPACK FOOTER //
// ./src/utilities/currency.js